import React from 'react';
import { FaGithub, FaLinkedinIn, FaTwitter  } from "../utils/Icons";

const Socials = () => {
  return (
    <>
      <a
        href="https://github.com/grzafnan"
        target="_blank"
        aria-label="View Shakil's GitHub profile — open source work and repositories"
        rel="noopener noreferrer"
        className="bannerIcon"
      >
        <FaGithub />
      </a>
      <a
        href="https://www.linkedin.com/in/shakilahmmed1"
        target="_blank"
        aria-label="Connect with Shakil on LinkedIn"
        rel="noopener noreferrer"
        className="bannerIcon"
      >
        <FaLinkedinIn />
      </a>
      <a
        href="https://twitter.com/shakil_ahmmed7"
        target="_blank"
        aria-label="Follow Shakil on Twitter / X"
        rel="noopener noreferrer"
        className="bannerIcon"
      >
        <FaTwitter />
      </a>
    </>
  );
};

export default Socials;